import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { PointOfInterest } from "../../store/admin/pointOfInterest";

export interface PointsInterestListParams {
  page?: number;
  limit?: number;
  status_id?: string;
  category_id?: string;
  search?: string;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface PointsInterestBody {
  data?: PointOfInterest[];
  meta?: ListMeta;
}

export interface PointsInterestListResult {
  data: PointOfInterest[];
  meta?: ListMeta;
}

function cleanParams(
  params: PointsInterestListParams,
): Record<string, string | number> {
  const out: Record<string, string | number> = {
    page: params.page ?? 1,
    limit: params.limit ?? 6,
  };
  if (params.status_id) out.status_id = params.status_id;
  if (params.category_id) out.category_id = params.category_id;
  if (params.search) out.search = params.search;
  return out;
}

export function usePointsInterestList(
  params: PointsInterestListParams = {},
  options: { enabled?: boolean } = {},
) {
  const companyId = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.pointsInterest.list(companyId, params),
    queryFn: ({ signal }) =>
      getJson<PointsInterestBody>("/pointsInterestList", cleanParams(params), {
        signal,
      }).then((body) => ({ data: body.data ?? [], meta: body.meta })),
    enabled: options.enabled ?? true,
  });
}
